interface WidgetLibraryCardProps {
    widget: {
        id: string;
        name: string;
        image?: string;
    };
    isExpanded: boolean;
    onToggle: () => void;
    disabled?: boolean;
    disabledMessage?: string;
}

export const WidgetLibraryCard = ({ widget, isExpanded, onToggle, disabled = false, disabledMessage }: WidgetLibraryCardProps) => {
    return (
        <div
            className={`
                w-full
                rounded-lg
                border border-slate-300 dark:border-slate-500
                bg-slate-100 dark:bg-slate-700
                shadow
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-slate-200 dark:hover:bg-slate-600 hover:shadow-md cursor-pointer'}
                transition
                overflow-hidden
                relative
            `}
            onClick={(e) => {
                if (!disabled) {
                    e.stopPropagation();
                    onToggle();
                }
            }}
        >
            {/* Disabled overlay */}
            {disabled && (
                <div className="absolute inset-0 bg-black bg-opacity-10 flex items-center justify-center z-10">
                    <div className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-medium">
                        {disabledMessage || 'Widget disabled'}
                    </div>
                </div>
            )}
            
            {/* Widget Name - Always Visible */}
            <div className="px-4 py-3 flex items-center justify-between">
                <span
                    className={`
                        text-xs
                        font-semibold
                        ${disabled ? 'text-slate-500 dark:text-slate-400' : 'text-slate-800 dark:text-slate-100'}
                        truncate
                        flex-1
                    `}
                    title={widget.name}
                >
                    {widget.name}
                </span>
                <span className={`${disabled ? 'text-slate-400 dark:text-slate-500' : 'text-slate-600 dark:text-slate-400'} ml-2`}>
                    {isExpanded ? '▾' : '▸'}
                </span>
            </div>

            {/* Image - Only visible when expanded */}
            {isExpanded && (
                <div className="px-4 pb-4">
                    <div className="w-full min-h-32 rounded-md overflow-hidden bg-slate-200 dark:bg-slate-600 flex items-center justify-center">
                        {widget.image ? (
                            <img
                                src={widget.image}
                                alt={widget.name}
                                className="w-full h-auto max-h-64 object-contain"
                            />
                        ) : (
                            <div className="w-full h-32 flex items-center justify-center text-slate-400 text-xs">
                                No preview available
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

